import { useCallback, useEffect, useState } from 'react';
import { latestReleaseDate } from '../help/releases';

const SEEN_KEY = 'whatsNewSeen';
const SEEN_EVENT = 'whats-new-seen';

const readSeen = () => {
  try {
    return localStorage.getItem(SEEN_KEY) ?? '';
  } catch {
    return '';
  }
};

/**
 * Van-e olyan újdonság, amit a felhasználó ezen az eszközön még nem nézett meg.
 * A Funkciók oldal megnyitása "látottnak" jelöli - a jelzés minden példánya
 * (menü, kezdőlap) egyszerre frissül.
 */
export const useWhatsNew = () => {
  const [seen, setSeen] = useState(readSeen);

  useEffect(() => {
    const sync = () => setSeen(readSeen());
    window.addEventListener(SEEN_EVENT, sync);
    return () => window.removeEventListener(SEEN_EVENT, sync);
  }, []);

  const markSeen = useCallback(() => {
    try {
      localStorage.setItem(SEEN_KEY, latestReleaseDate);
    } catch {
      /* nem baj, ha nem marad meg */
    }
    window.dispatchEvent(new Event(SEEN_EVENT));
  }, []);

  return { hasUnseen: latestReleaseDate !== '' && seen < latestReleaseDate, seen, markSeen };
};
